import appEventLogsComponent from "./app_event_logs.component";

let appEventLogsModule = angular
  .module("appEventLogs", [])

  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";

    $urlRouterProvider.otherwise("/appEventLogs");

    $stateProvider.state("appEventLogs", {
      url: "/v2/index.html#/tnt-app-event-logs",
      component: "appEventLogs",
      data: {
        requireLogin: true,
        requireACL: "tnt_app_event_logs.all",
      },
    });
  })
  .component("appEventLogs", appEventLogsComponent).name;

export default appEventLogsModule;



// WEBPACK FOOTER //
// ./client/app/components/app_event_logs/index.js